import React from 'react';
import { useLanguage } from '@/context/LanguageContext';
import { Globe } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';

const LanguageSwitcher = ({ variant = 'default' }) => {
  const { language, setLanguage, t } = useLanguage();

  const languages = [
    { code: 'tr', name: 'Türkçe', flag: '🇹🇷' },
    { code: 'en', name: 'English', flag: '🇬🇧' },
  ];

  const currentLang = languages.find((l) => l.code === language);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          className={`flex items-center gap-2 px-3 py-2 rounded-full border border-border/50 hover:border-primary/50 hover:bg-card transition-smooth ${
            variant === 'header' ? 'text-sm' : ''
          }`}
        >
          <span className="text-base">{currentLang?.flag}</span>
          <span className="text-foreground font-body text-sm uppercase tracking-wide">
            {language.toUpperCase()}
          </span>
          <Globe className="w-4 h-4 text-muted-foreground" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="start"
        className="bg-card border-border/50 min-w-[140px]"
      >
        {languages.map((lang) => (
          <DropdownMenuItem
            key={lang.code}
            onClick={() => setLanguage(lang.code)}
            className={`flex items-center gap-3 cursor-pointer hover:bg-muted transition-smooth ${
              language === lang.code ? 'bg-muted text-primary' : 'text-foreground'
            }`}
          >
            <span className="text-lg">{lang.flag}</span>
            <span className="font-body">{lang.name}</span>
            {language === lang.code && (
              <span className="ml-auto text-primary">✓</span>
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSwitcher;
